import { render, staticRenderFns } from "./recharge_record_detail.vue?vue&type=template&id=4d404735"
import script from "./recharge_record_detail.vue?vue&type=script&lang=js"
export * from "./recharge_record_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports